
<template>
    <iframe 
        :src="Constants.ServerUrl + '/service/devize/deviz_produse/' + IdDeviz" 
        width="100%" 
        :height="parentHeight"
        style="border: none;">
</iframe>                 
    
</template>
 
<script>
import settings from "@/backend/LocalSettings"
import BasePage from '@/pages/Admin/BasePage' 
import Constants from '@/backend/Constants'
export default {
    name: "deviz_produse_pdf",
    extends: BasePage,

    data(){
        return {
            Constants: Constants,
            IdDeviz: this.$route.params.IdDeviz,
            parentHeight: 1000,        
        }
    },
    methods: {

    },
    async mounted() {

        var  response = await this.$http.post('login/check_php_login', {token: settings.get_token} );
        if(response) {
            if(response.body.token_activ == 0)  this.$router.push("/");
        } else {
            this.$router.push("/");
        }
    }
}
</script>

